import { useEffect, type Dispatch } from 'react';

import { sendChatStream } from '../../../services/api/ai';
import { type SuggestedAction } from '../../../types/ai';
import { type AnnouncementBanner } from '../../../types/announcements';
import { type ConversationAction } from '../conversation-reducer';
import {
  LANG_TO_SIMULATED_MARKET,
  WELCOME_SEED_BY_LANG,
  WELCOME_SEED_FALLBACK,
} from '../constants';

export const useWelcomeSeed = ({
  sessionId,
  language,
  generation,
  dispatch,
}: {
  sessionId: string;
  language: string;
  generation: number;
  dispatch: Dispatch<ConversationAction>;
}) => {
  useEffect(() => {
    const simulatedMarket = LANG_TO_SIMULATED_MARKET[language];
    let welcomeText = '';
    let welcomeActions: SuggestedAction[] | null = null;
    let welcomeAnnouncement: AnnouncementBanner | undefined;

    void sendChatStream(
      {
        message: WELCOME_SEED_BY_LANG[language] ?? WELCOME_SEED_FALLBACK,
        silent: true,
        channel: 'website',
        sessionId,
        metadata: {
          clientSurface: 'playground',
          language,
          ...(simulatedMarket
            ? {
                siteContext: {
                  hostname: simulatedMarket.hostname,
                  pathname: '/',
                  pageType: 'start',
                },
              }
            : {}),
        },
      },
      {
        onChunk: (chunk) => {
          welcomeText += chunk;
        },
        onSuggestedActions: (actions) => {
          welcomeActions = actions;
        },
        onAnnouncement: (banner) => {
          welcomeAnnouncement = banner;
        },
      },
    )
      .then((res) => {
        const content = (welcomeText || res?.message || '').trim();
        if (!content) return;
        dispatch({
          type: 'welcome/filled',
          generation,
          content,
          suggestedActions: welcomeActions ?? undefined,
          announcement: welcomeAnnouncement,
        });
      })
      .catch(() => {});
    // Bara sessionId. Ett språkbyte skapar ett nytt sessionId via resetConversationState —
    // har språket med i listan seedas välkomsten två gånger per byte.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);
};
